export default __webpack_public_path__ + "static/media/def_female_pic.94779d3d.png";